import { SetStateAction } from "react";

const regex = {
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // בדיקת אימייל תקין
    passwordStrength: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/, // סיסמה: לפחות 8 תווים, אות אחת ומספר אחד
    password: /^(?=.*[A-Z])(?=.*[0-9]).+/,
    phone: /^(\+?\d{1,4}[-.\s]?)?(\(?\d{1,4}\)?[-.\s]?)?\d{1,4}[-.\s]?\d{1,9}$/, // מספר טלפון
    url: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/, // כתובת URL
    username: /^[a-zA-Z0-9_]{3,20}$/, // שם משתמש: 3-20 תווים, רק אותיות, מספרים וקו תחתון
    hebrewLetters: /^[א-ת\s]+$/, // רק אותיות בעברית
    postalCode: /^\d{5,7}$/, // קוד דואר: 5-7 ספרות
    passwordWithUpperCaseAndDigit: /^(?=.*[A-Z])(?=.*\d).+$/, // סיסמה: לפחות אות גדולה ומספר אחד
    MobilePhoneRegex: /^[0][5][0-9|1|2|3|4|5|8|9]{1}[-]{0,1}[2-9]{1}[0-9]{6}$/, // regex for Israeli mobile phone number
    PhoneRegex: /^(972|0)(-)?0?(([23489]{1}-?[0-9]{7})|[5]{1}[0-9]{8})$/, // regex for Israeli phone number
  
  };
  
  export default regex;
  

  export const validateEmail = (value: string, t: { (value: SetStateAction<boolean>): void; (arg0: string): any; }) => {
    if (!value) {
      return t("Validation-Required"); 
    } else if (!regex.email.test(value)) {
      return t("Validation-InvalidEmail"); 
    } else {
      
      return "";
    }
  };

  export const validatePassword = (
    value: string,
    t: (key: string) => string
  ): string => {
    if (!value) {
      return t("Validation-Required"); // הודעה לשדה חובה
    }  else if (!regex.password.test(value)) {
      return `${t("Validation-Password-Policy")} `}
      else if (value.length < parseInt(t("Password-min-chars"))) {
      return `${t("Validation-MinimumLength")} ${t("Password-min-chars")}`;
    } else if (value.length > parseInt(t("Password-max-chars"))) {
      return `${t("Validation-MaximumLength")} ${t("Password-max-chars")}`;
    } else {
      return ""; // סיסמה תקינה
    }
  };